import { render, staticRenderFns } from "./MerchantRecruit.vue?vue&type=template&id=0e63f9bd&"
import script from "./MerchantRecruit.vue?vue&type=script&lang=js&"
export * from "./MerchantRecruit.vue?vue&type=script&lang=js&"
import style0 from "./MerchantRecruit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports